export default __webpack_public_path__ + "static/media/ico-finance.e37f9c01.svg";